var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"info-box comment-box"},[_c('div',{staticClass:"info-box-header"},[_c('div',{staticClass:"info-box-title"},[_vm._v(_vm._s(_vm.title))])]),_c('div',{staticClass:"info-box-body",domProps:{"innerHTML":_vm._s(_vm.bodyHTML)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }